import reduce from 'lodash/reduce';
export const parseQuery = (query) => {
    const parts = query
        .split('and')
        .map((part) => part.trim())
        .map((part) => part.replace(/[()]/g, ''));
    return parts.reduce((accum, part) => {
        const [key = '', val = ''] = part.split(':');
        accum[key.trim()] = parseInt(val, 10);
        return accum;
    }, {});
};
const doesQueryMatch = (queryables, query) => {
    return [
        queryables.width >= (query['min-width'] || 0),
        queryables.width <= (query['max-width'] || Infinity),
    ].every(Boolean);
};
export const findMatchingQueries = (queryables, queries) => {
    return reduce(queries, (accum, queryToCheck) => {
        const mediaQuery = queryToCheck;
        const parsedQuery = parseQuery(mediaQuery);
        accum[queryToCheck] = doesQueryMatch(queryables, parsedQuery);
        return accum;
    }, {});
};
export default findMatchingQueries;
//# sourceMappingURL=findMatchingQueries.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
